const POLL_INTERVAL = 15 * 1000;
const INITIAL_DELAY = 30 * 1000;

export default {
  name: 'deployNotification',

  getReducer: () => {
    const initialData = {
      updateAvailable: false,
      currentCommitRef: process.env.REACT_APP_COMMIT_REF || 'local',
      currentBranch: process.env.REACT_APP_BRANCH || 'local',
      dismissed: false,
    };

    return (state = initialData, { type }) => {
      if (type === 'DEPLOY_UPDATE_AVAILABLE') {
        return { ...state, updateAvailable: true };
      }

      if (type === 'DEPLOY_NOTIFICATION_DISMISSED') {
        return { ...state, dismissed: true };
      }

      return state;
    };
  },

  doCheckForDeploy:
    () =>
    async ({ dispatch, getState, store }) => {
      const authenticatedUser = store.selectAuthenticatedUser(getState());
      if (
        !authenticatedUser ||
        !authenticatedUser.isAuthorized('ui.split.test')
      ) {
        return;
      }

      try {
        const response = await fetch('/deploy-meta.json', {
          cache: 'no-store',
        });
        if (!response.ok) return;

        const data = await response.json();
        const { currentCommitRef, currentBranch } = getState().deployNotification;

        if (
          data.commitRef !== currentCommitRef &&
          data.branch === currentBranch &&
          currentCommitRef !== 'local'
        ) {
          dispatch({ type: 'DEPLOY_UPDATE_AVAILABLE' });
        }
      } catch {
        // Silently ignore — will retry on next poll
      }
    },

  doDismissDeployNotification: () => ({ dispatch }) => {
    dispatch({ type: 'DEPLOY_NOTIFICATION_DISMISSED' });
  },

  doReloadForDeploy: () => () => {
    window.location.reload();
  },

  selectUpdateAvailable: state =>
    state.deployNotification.updateAvailable &&
    !state.deployNotification.dismissed,

  init: store => {
    if (process.env.NODE_ENV !== 'production') return;
    if ((process.env.REACT_APP_COMMIT_REF || 'local') === 'local') return;

    setTimeout(() => {
      store.doCheckForDeploy();
    }, INITIAL_DELAY);

    setInterval(() => {
      store.doCheckForDeploy();
    }, POLL_INTERVAL);
  },
};
